import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { KaizenImpactingModel, PagedResponseKaizenImpactingModel } from '../models/KaizenImpactingModel';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class KaizenImpactingModelService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getKaizenImpactingModels():Observable<PagedResponseKaizenImpactingModel>{
    const data =  this.http.get<PagedResponseKaizenImpactingModel>(this.APIURL+'/KaizenImpactingModel' + '?PageNumber=1&PageSize=50');
    this.messageService.add('Line Service: fetched shops');
    return data;
  }

  getKaizenImpactingModel(id: number): Observable<KaizenImpactingModel> {
    const Line =this.http.get<KaizenImpactingModel>(this.APIURL+'/KaizenImpactingModel/' + id);
    this.messageService.add(`KaizenImpactingModel Service: fetched KaizenImpactingModel with id=${id}`);
    return Line;
  }
}